const s = {
  name: "CurrencyKuwaitiDinarV2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,11H9v18h2v-5.6l1-1.5l4.6,7.2H19l-5.8-9l5.8-9h-2.4L11,19.7V11z"/>
		<path class="st0" d="M26,11h-5v18h5c2.8,0,5-2.2,5-5v-8C31,13.2,28.8,11,26,11z M26,27h-3V13h3c1.7,0,3,1.3,3,3v8
			C29,25.7,27.7,27,26,27z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyKuwaitiDinarV2
};
